export default __webpack_public_path__ + "static/media/detaliu-dauna.1eeceb2f.png";